import * as React from 'react';
import { FixMeLater } from '../../../utils';
import { Styler, StylerProps } from '../../Styler';
import { DIALOG_STATIC_STYLES } from '../Dialog.styles';

export interface DialogFooterProps extends StylerProps {
    /**
     * If `true`, the footer will have a top border.
     * @default true;
     */
    border?: boolean;
}

export const DialogFooter = React.forwardRef(function DialogFooter(
    props: DialogFooterProps,
    ref: React.ForwardedRef<FixMeLater>
): React.JSX.Element {
    const { children, border = true, ...other } = props;

    return (
        <Styler
            ref={ref}
            baseStyles={DIALOG_STATIC_STYLES.bar}
            data-dialog-footer={true}
            data-border={border || undefined}
            data-default-gutters={true}
            {...other}
        >
            {children}
        </Styler>
    );
});
